import { memo } from 'react';

interface ToastMessageProps {
  title: string;
  message: string | React.ReactNode;
  bottom?: React.ReactNode;
}

export const ToastMessage = memo(({ title, message, bottom }: ToastMessageProps) => {
  return (
    <div>
      <h1 className="text-bolt-elements-textPrimary font-medium">{title}</h1>
      <div className="text-bolt-elements-textSecondary">{message}</div>
      {bottom ? <div className="w-full flex items-center pt-2">{bottom}</div> : undefined}
    </div>
  );
});
